import axios from 'axios';

export interface Params {
  [key: string]: any;
}

export const postPatientData = async (baseUrl: string, params: Params): Promise<any> => {
  try {
    const response = await axios.post(baseUrl, params, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const getAppointments = async (baseUrl: string): Promise<any> => {
  try {
    const response = await axios.get(baseUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};
